import { libraryDeck } from "./libraryDeck";
import { materialsCreateDeck } from "./materialsCreateDeck";
import { materialsMapDeck } from "./materialsMapDeck";
import { platformDeck } from "./platformDeck";
import { projectDeck } from "./projectDeck";
import { viewerDeck } from "./viewerDeck";
import type { WelcomeDeck, WelcomeDeckId } from "./WelcomeDeck";

const decksById: Record<WelcomeDeckId, WelcomeDeck> = {
  platform: platformDeck,
  project: projectDeck,
  library: libraryDeck,
  viewer: viewerDeck,
  materialsCreate: materialsCreateDeck,
  materialsMap: materialsMapDeck,
};

export function getWelcomeDeck(id: WelcomeDeckId): WelcomeDeck {
  return decksById[id];
}

export { platformDeck, projectDeck, libraryDeck, viewerDeck, materialsCreateDeck, materialsMapDeck };
export { orderStepsForDeck } from "./orderStepsForDeck";
export type { WelcomeDeck, WelcomeDeckId, WelcomeEndingContext, WelcomeEndingRunContext } from "./WelcomeDeck";
